import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Icon } from '@material-ui/core';

import PageInfo from './pageInfo';

const PageAdd = () => {
  const [goToPageListScreen, setGoToPageListScreen] = useState(false);

  const pageInfoHandled = () => {
    try {
      setGoToPageListScreen(true);
    } catch (error) {
      console.log('Error in pageInfoHandled:');
      console.log(error);
    }
  };

  return goToPageListScreen ? <Redirect to="/admin/page" /> : (
    <>
      <div className="content-header">
        <h1 className="d-flex align-items-center">
          <Link to="/admin/page" title="Back" className="d-flex align-items-center">
            <Icon className="back">arrow_back</Icon>
          </Link>
          Add Page
        </h1>
      </div>
      <div className="row">
        <div className="col-lg-12 col-12 card-left">
          <PageInfo pageInfoHandled={pageInfoHandled} />
        </div>
      </div>
    </>
  );
};

PageAdd.postTypes = {
};

export default connect(null, {})(PageAdd);
